/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_All_RolesInputs */

const en_admin_roles_all_roles = /** @type {(inputs: Admin_Roles_All_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Roles`)
};

/**
* | output |
* | --- |
* | "All Roles" |
*
* @param {Admin_Roles_All_RolesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_all_roles = /** @type {((inputs?: Admin_Roles_All_RolesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_All_RolesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_all_roles(inputs)
});
export { admin_roles_all_roles as "admin.roles.all_roles" }